import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import CustomizedCheckbox from "commonComponents/FormElement/Checkbox";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserBasic,
    isUserReadOnly,
    isUserAdmin
} from "../../../../constant";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import {
    Heading,
    WorkSection,
    CheckBoxWrapper,
    ActionWrapper,
    TextAreaBox,
    TimeOut
} from "pages/Fleet/Settings/SettingsStyled";
import { Loader } from "commonComponents/Loader/Loader";
import { useHookstate } from "@hookstate/core";
import { CenteredLoader } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import {
    MAX_HOLES_GLOBAL_STATE,
    SITEID_GLOBAL_STATE,
    CHECKBOX_LOADER
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import SelectStyled from "commonComponents/FormElement/Select";

export const RoundManagementAccordion = ({ handleTextRoundManagementOnSave,
    handleTextRoundManagementOnReset,
    roundManagementButton,
    setRoundManagementButton,
    messageBoxValue,
    setMessageBoxValue,
    messageBoxCount,
    setMessageBoxCount,
    roundTimeout,
    setRoundTimeout,
    stagingTimeout,
    resetRoundTimeout,
    resetStagingTimeout,
    setStagingTimeout
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const { roundManagementLoader, LoadingState } = useHookstate(CHECKBOX_LOADER);

    const { maxHolesAllowed, detectChangeMaxHolesAllowed } = useHookstate(MAX_HOLES_GLOBAL_STATE);

    const { siteSettingsData, getUserRole } = useSelector((state) => state?.commonReducers) || [];

    const paceSettingsData = useSelector((state) => state?.commonReducers?.getRoundTimeOutData) || [];

    const [roundTimeoutSecondsButton, setRoundTimeoutSecondsButton] = useState(false);

    const handleWelcomeScreenText = (e) => {
        setRoundManagementButton(true);
        setMessageBoxValue(e.target.value);
        setMessageBoxCount(e.target.value.length);
    }

    const handleSubmitRoundTimeoutSeconds = () => {
        setRoundTimeoutSecondsButton(false);
        const site = {
            ...paceSettingsData,
            site: {
                ...paceSettingsData.site,
                StagingTimeoutSeconds: (stagingTimeout * 60).toString(),
                RoundTimeoutSeconds: (roundTimeout * 60).toString(),
            },
        };
        const payload = {
            siteId: Number(siteId.get()),
            siteSettings: siteSettingsData,
            paceSettings: site,
        };
        LoadingState.set(true);
        roundManagementLoader.set(true);
        dispatch(
            COMMON_SERVICES.putRoundTimeOutServices(payload, Number(siteId.get()))
        );
        setTimeout(() => {
            LoadingState.set(false);
            roundManagementLoader.set(false);
        }, 2000);
    }

    const handleRound = (e) => {
        setRoundTimeoutSecondsButton(true);
        setRoundTimeout(e.target.value);
    }

    const holesList = [
        {
            value: "0",
            label: t("No_Limit"),
        },
        {
            value: "9",
            label: "9",
        },
        {
            value: "18",
            label: "18 ",
        },
    ];

    const handleSaveMaxHolesAllowed = () => {
        const maxHoleValue = maxHolesAllowed.value.toString();
        roundManagementLoader.set(true);
        dispatch(
            COMMON_SERVICES.putMaxHolesNumService(maxHoleValue, siteId.get())
        ).then(() => {
            detectChangeMaxHolesAllowed.set(false);
            roundManagementLoader.set(false);
        });
    }

    const handleResetMaxHolesAllowed = () => {
        detectChangeMaxHolesAllowed.set(false);
        maxHolesAllowed.set(
            siteSettingsData && siteSettingsData?.MaxHolesAllowedFleet
        );
    }

    function handleReset() {
        setRoundTimeoutSecondsButton(false);
        setRoundTimeout(resetRoundTimeout);
        setStagingTimeout(resetStagingTimeout);
    }

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Heading>
                        <h3>{t("Round_Management")}</h3>
                    </Heading>
                </AccordionSummary>
                <AccordionDetails>
                    <WorkSection>
                        {roundManagementLoader.get() && (
                            <CenteredLoader className="innerSectionLoader">
                                <Loader />
                            </CenteredLoader>
                        )}
                        <div>
                            <TextAreaBox>
                                <p className="label">{t("Welcome_Screen_text")}</p>
                                <textarea
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    id="screen"
                                    name="screen"
                                    rows="3"
                                    cols="50"
                                    value={messageBoxValue}
                                    onChange={(e) => handleWelcomeScreenText(e)}
                                    maxLength={60}
                                    style={{ resize: "none" }}
                                ></textarea>
                                <span>
                                    {messageBoxCount}/60 {t("chars_remaining")}
                                </span>
                            </TextAreaBox>
                            <ActionWrapper>
                                <Button
                                    variant="outlined"
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={() => handleTextRoundManagementOnSave("screen")}
                                    className={roundManagementButton ? "active" : "disabled"}
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    variant="outlined"
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    className="send-btn"
                                    onClick={() => handleTextRoundManagementOnReset("screen")}
                                >
                                    {t("Reset")}
                                </Button>
                            </ActionWrapper>
                        </div>
                        <div>
                            <TimeOut>
                                <div>
                                    <p className="label">{t("Round_timeout")} </p>
                                    <input
                                        disabled={!isUserAdmin(getUserRole && getUserRole?.Role)}
                                        type="number"
                                        min={0}
                                        max={99}
                                        value={roundTimeout}
                                        onChange={(e) => handleRound(e)}
                                    />
                                    <span>mins</span>
                                </div>
                            </TimeOut>
                            <TimeOut>
                                <div>
                                    <p className="label">{t("Staging_timeout")} </p>
                                    <input
                                        disabled={isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)}
                                        type="number"
                                        min={0}
                                        max={99}
                                        value={stagingTimeout}
                                        onChange={(e) => {
                                            setStagingTimeout(e.target.value);
                                            setRoundTimeoutSecondsButton(true);
                                        }}
                                    />
                                    <span>mins</span>
                                </div>
                            </TimeOut>
                            <ActionWrapper className="mb-40">
                                <Button
                                    variant="outlined"
                                    disabled={
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={handleSubmitRoundTimeoutSeconds}
                                    className={roundTimeoutSecondsButton ? "active" : "disabled"}
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    variant="outlined"
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().real_time_tracking
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                    onClick={handleReset}
                                    className="send-btn"
                                >
                                    {t("Reset")}
                                </Button>
                            </ActionWrapper>
                        </div>
                        <div className="select-wrapper">
                            <p className="label">{t("Max_Number_of_Holes")}</p>
                            <SelectStyled
                                disabled={
                                    getFeatureSetOption(
                                        siteSettingsData && siteSettingsData?.Features,
                                        getFeaturesList().golfer_experience
                                    ) ||
                                    isUserBasic(getUserRole && getUserRole?.Role) ||
                                    isUserReadOnly(getUserRole && getUserRole?.Role)
                                }
                                value={maxHolesAllowed.get()}
                                data={holesList}
                                IconComponent={ExpandMoreIcon}
                            />

                            <ActionWrapper className="mb-40">
                                <Button
                                    variant="outlined"
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                        !detectChangeMaxHolesAllowed.get()
                                    }
                                    onClick={() => handleSaveMaxHolesAllowed()}
                                    className={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                            isUserBasic(getUserRole && getUserRole?.Role) ||
                                            isUserReadOnly(getUserRole && getUserRole?.Role) ||
                                            !detectChangeMaxHolesAllowed.get()
                                            ? ""
                                            : "active"
                                    }
                                >
                                    {t("Save")}
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => handleResetMaxHolesAllowed()}
                                    className="send-btn"
                                >
                                    {t("Reset")}
                                </Button>
                            </ActionWrapper>

                            <CheckBoxWrapper className="mb-10">
                                <CustomizedCheckbox
                                    lockdownText="showOverMaxHoles"
                                    label={t("Show_Over_Max_Holes_on_Cart")}
                                    name="Show Over Max Holes on Cart"
                                    width={15}
                                    height={15}
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                />
                            </CheckBoxWrapper>
                            <CheckBoxWrapper className="mb-10">
                                <CustomizedCheckbox
                                    lockdownText="disableDistancesOnMaxHoles"
                                    label={t("Disable_Distances_on_Max_Holes")}
                                    name="Disable Distances on Max Holes"
                                    width={15}
                                    height={15}
                                    disabled={
                                        getFeatureSetOption(
                                            siteSettingsData && siteSettingsData?.Features,
                                            getFeaturesList().golfer_experience
                                        ) ||
                                        isUserBasic(getUserRole && getUserRole?.Role) ||
                                        isUserReadOnly(getUserRole && getUserRole?.Role)
                                    }
                                />
                            </CheckBoxWrapper>

                        </div>
                    </WorkSection>
                </AccordionDetails>
            </Accordion>
        </>
    );
};